import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    ProviderSlug} from "@@/shared/providers/provider";
import {
    providerSlugZodSchema,
} from "@@/shared/providers/provider";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderSetNewSlugCommand = {
    _type: "PROVIDER_SET_NEW_SLUG_COMMAND";
    _createdAt: IsoAndUnixTimestamp;
    providerId: ProviderId;
    slug: ProviderSlug;
};

const providerSetNewSlugCommandZodSchema: z.ZodSchema<ProviderSetNewSlugCommand> =
    z.object({
        _type: z.literal("PROVIDER_SET_NEW_SLUG_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        slug: providerSlugZodSchema,
    });

type FactoryParams = Except<ProviderSetNewSlugCommand, "_type" | "_createdAt">;
const providerSetNewSlugCommandFactory = (
    params: FactoryParams,
): ProviderSetNewSlugCommand => {
    return {
        ...params,
        _type: "PROVIDER_SET_NEW_SLUG_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};

export { providerSetNewSlugCommandFactory, providerSetNewSlugCommandZodSchema };
export type { ProviderSetNewSlugCommand };
